import OpportunitiesPage from './OpportunitiesPage'

export default OpportunitiesPage
